
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { tSearch } from '@/components/Search/index';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/course';
import bModal from './components/bModal.vue';
import tableMixin from './tableMixin';
import SearchForm from './components/searchForm.vue';

@Component({
  components: {
    Pagination,
    tSearch,
    SearchForm,
    bModal,
  },
})
export default class infoView extends Mixins(tableMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/course/info:add',
    icon: 'plus',
    callback: this.handleAddCourse,
    log: {
      name: '正式课 - 新增',
      component: '/course/manage:add',
    },
  }];

  private visible: boolean = false;

  private title: string = '添加正式课';

  private form: any = [];

  private searchValue: string = '';

  private normalValue: string = ''

  private searchFormValue: string = '';

  public $refs!: {
    searchForm: SearchForm;
  }

  /**
   * @author liangyongmou
   * @desc 打开添加正式课模态框
   */
  handleAddCourse() {
    this.title = '添加正式课';
    this.visible = true;
  }

  handleSearchChange(v: string) {
    this.normalValue = v;
    this.getData({ title: v });
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索提交事件
   */
  handleAdvancedSearch() {
    const form: any = this.$refs.searchForm.getFormData();
    const params: any = {
      title: form.title,
      tid: form.tid,
      standardNumber: form.standardNumber,
      version: form.version,
    };
    const tid: any = [];
    params.tid = params.tid.forEach((item: any) => { // 获取课程分类所有子节点
      tid.push(item[1]);
    });
    params.tid = tid.toString();
    const flag: boolean = Object.values(params).some((em: any) => {
      return em && em.length > 0;
    });
    if (flag) this.getData(params);
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索普通搜索切换事件
   * @param { boolean } activate 是否切换
   */
  handleActivateChange(activate: boolean) {
    if (activate) {
      this.$refs.searchForm.setTitle(this.searchValue);
      this.searchValue = '';
    } else this.searchValue = this.$refs.searchForm.getFormData().title;
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索清空按钮事件
   */
  handleAdvanceClear() {
    this.$refs.searchForm.handleClear();
    this.getData();
  }

  /**
   * @author liangyongmou
   * @desc 编辑正式课事件
   * @params { any } row 行数据
   */
  handleEdit(row: any) {
    this.title = '编辑正式课';
    this.visible = true;
    this.form = row;
  }

  // 修改正式课内容
  handleEditContent(row: any) {
    this.title = '编辑正式课内容';
    this.visible = true;
    this.form = row;
  }

  getNewData() {
    this.getData({ title: this.normalValue });
  }


  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
